import { DeviceConfigParams } from "../../DeviceConfigParams";
export class Rcz21ConfigParams extends DeviceConfigParams {
    constructor() {
        super(...arguments);
        this.AlertMode = FloodSensorAlertMode.AlarmAndLed;
        this.RepeatFloodEvent = false;
        this.RepeatFloodEventTime = 900;
        this.WorkingMode = FloodSensorWorkingMode.FloodSensor;
        this.SyncTime = 720;
    }
}
export var FloodSensorAlertMode;
(function (FloodSensorAlertMode) {
    FloodSensorAlertMode[FloodSensorAlertMode["None"] = 0] = "None";
    FloodSensorAlertMode[FloodSensorAlertMode["Alarm"] = 1] = "Alarm";
    FloodSensorAlertMode[FloodSensorAlertMode["Led"] = 2] = "Led";
    FloodSensorAlertMode[FloodSensorAlertMode["AlarmAndLed"] = 3] = "AlarmAndLed";
})(FloodSensorAlertMode || (FloodSensorAlertMode = {}));
export var FloodSensorWorkingMode;
(function (FloodSensorWorkingMode) {
    FloodSensorWorkingMode[FloodSensorWorkingMode["FloodSensor"] = 0] = "FloodSensor";
    FloodSensorWorkingMode[FloodSensorWorkingMode["PulseSensor"] = 1] = "PulseSensor";
})(FloodSensorWorkingMode || (FloodSensorWorkingMode = {}));
//# sourceMappingURL=Rcz21ConfigParams.js.map